import * as types from '../actions/types'

const initialState = []

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_ALL_SHIPPERS: {
      return [...state, ...payload]
    }
    case types.CLEAR_SHIPPERS: {
      return []
    }

    default:
      return state
  }
}
